import { envConfig } from '@/config/envConfig';
import { CheckoutProvider } from '@stripe/react-stripe-js';
import { useMutation } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { createSinglePaymentCheckoutSession } from '../api';
import { CreateSinglePaymentCheckoutSessionPayloadType } from '@/api/v1/billing/createSinglePaymentCheckoutSessionApi';
import { showSnackbarResponseError } from '@/helpers/helpers';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(envConfig.STRIPE_API_KEY, {
  developerTools: { assistant: { enabled: envConfig.IS_DEVELOPMENT || envConfig.IS_STAGING } },
});

type SubscriptionCheckoutProviderType = {
  wiresQuantity: number;
  children: ReactNode;
  onError: () => void;
};

export const SinglePaymentCheckoutProvider = ({
  wiresQuantity,
  children,
  onError,
}: SubscriptionCheckoutProviderType) => {
  const { mutateAsync } = useMutation({
    mutationKey: ['create_single_payment_checkout_session'],
    mutationFn: () => {
      const payload: CreateSinglePaymentCheckoutSessionPayloadType = {
        ui_mode: 'custom',
        quantity: wiresQuantity,
        return_url: window.location.href,
      };

      return createSinglePaymentCheckoutSession(payload);
    },
  });

  const fetchClientSecret = async () => {
    return mutateAsync().then((response) => {
      if (response?.error) {
        showSnackbarResponseError(response?.error);
        onError();

        return '';
      }

      return response?.body?.client_secret;
    });
  };

  return (
    <CheckoutProvider stripe={stripePromise} options={{ fetchClientSecret }}>
      {children}
    </CheckoutProvider>
  );
};
